<script setup lang="ts">
import { TotemTeleportDestination } from '@totem/vue';
import { useHead } from '@unhead/vue';

import useMarque from '@/plugins/layout/lib/UseMarque';

const { marqueName } = useMarque();

useHead({
  title: import.meta.env.VITE_APP_NAME,
});
</script>

<template>
  <div class="app" :data-theme="marqueName">
    <RouterView />

    <TotemTeleportDestination />
  </div>
</template>

<style lang="scss">
@use '@totem/scss/normalize.css';
@use '@totem/scss/font-faces.scss';
@use '@totem/scss/components.scss';
@use '@totem/scss' as totem;
@use '@totem/scss/themes/alptis.scss' as alptis-theme;

:root {
  @include totem.init-theme-variables(alptis-theme.$variables);

  --header-height: 72px;
  --breadcrumb-height: 23px;

  --z-index-overall: 40;
  --z-index-header: 70;

  --nav-bar-width: 110px;
  --nav-menu-width: 246px;
  --nav-background: #505a5f;
  --nav-background-dark: #475054;
  --nav-background-darker: #363e41;
  --nav-background-darker-alpha-30: rgb(from var(--nav-background-darker) r g b / 30%);
  --nav-background-darker-alpha-50: rgb(from var(--nav-background-darker) r g b / 50%);
  --nav-background-light: #5c676c;
  --nav-background-lighter: #67747a;
}

@include totem.init-base();

.app {
  height: 100vh;
  position: relative;
}

body, html, ol, ul, li, dl, dt, dd, blockquote, p {
  margin: 0;
  padding: 0;
}

ul {
  list-style: none;
}

html {
  overflow: hidden auto;

  &.visible-scrollbar {
    overflow-y: scroll;
  }
}
</style>
